import styled from 'styled-components';

export const ButtonReleaseNotes = styled.button`
  padding-right: 15px;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ReleaseNoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  .release-date {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    color: var(--neutral_medium);
    background: #f4f8fb;
    border: 1px solid var(--neutral_lighter);
    border-radius: 999px;
    padding: 4px 12px;
  }

  .release-empty {
    font-size: 13px;
    color: gray;
  }
`;

type SectionAccent = {
  accent: string;
  soft: string;
};

export const SectionHeader = styled.div<SectionAccent>`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .section-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${(props) => props.soft};
    color: ${(props) => props.accent};
    font-size: 17px;
    flex-shrink: 0;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--neutral_dark);
  }
`;

export const SectionItems = styled.div<SectionAccent>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 46px;

  .release-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 14px 16px;
    background: #fafcfd;
    border: 1px solid var(--neutral_lighter);
    border-left: 3px solid ${(props) => props.accent};
    border-radius: 8px;
  }

  .release-item-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--neutral_dark);
  }

  .release-item-description {
    font-size: 13px;
    color: var(--neutral_medium);
    line-height: 20px;
  }

  .release-item-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }

  .release-deadline {
    font-size: 11px;
    color: var(--neutral_medium);
  }
`;

export const ReleaseHistoryContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid var(--neutral_lighter);
  padding-top: 8px;
`;

export const PaginationRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const HistoryLoading = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export const PopupCheckboxRow = styled.div`
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid var(--neutral_lighter);
`;
